import { Button, Container, createStyles, IconButton, withStyles, Tooltip } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Theme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import { AddBox, Close } from "@material-ui/icons";
import React, { MouseEventHandler, ReactElement } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { globalStyles } from "../../assets/globalStyles";
import { addTab, deleteTab, selectSelectedTab, selectTabs, setSelectedTab, selectViewMode } from "./netzwirtschaftSlice";
import { useStyles } from "./netzwirtschaftStyles";
import { TabData } from "./netzwirtschaftTypes";
import { NetzwirtschaftSavedSearch } from "./savedSearch";
import { NetzwirtschaftTab } from "./tab";
import { selectMessstellenLookup } from "../../features/messstellenLookup/messstellenLookupSlice";

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Netzwirtschaft(): ReactElement {
  const dispatch = useAppDispatch();

  const messstellenLookup = useAppSelector(selectMessstellenLookup);
  const viewMode = useAppSelector(selectViewMode);

  function getSchaltfeld(name: string) {
    const currentMessstelle = messstellenLookup.find((x) => x.name == name);
    if (currentMessstelle) return currentMessstelle.schaltfeld;
    return "";
  }

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const selectedTab: number = useAppSelector(selectSelectedTab),
    tabs: TabData[] = useAppSelector(selectTabs);

  const ButtonInTabs = (props: { onClick: MouseEventHandler<HTMLButtonElement>; children: JSX.Element[] | JSX.Element }) => {
    return <IconButton onClick={props.onClick}>{props.children}</IconButton>;
  };

  const [openSavedSearchesDialog, setOpenSavedSearchesDialog] = React.useState(false);

  const StyledTab = withStyles(
    (theme: Theme) =>
      createStyles({
        root: {
          "&.Mui-selected": {
            opacity: 1,
            backgroundColor: theme.palette.secondary.main,
          },
        },
      }),
    { index: 1 }
  )(Tab);

  return (
    <Container maxWidth={false} style={{ marginTop: "10px" }}>
      <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
        <Grid item md={3} />
        <Grid item md={6}>
          <Typography color="primary" variant="h5">
            Dashboard Analyse
          </Typography>
        </Grid>
      </Grid>
      <div>
        <Grid container md={12} spacing={2} style={{ paddingLeft: "9px", paddingRight: "0px" }}>
          <Grid container item md={10} style={{ paddingLeft: "0px" }}>
            <Tabs
              value={selectedTab}
              onChange={(event, value) => dispatch(setSelectedTab(value))}
              className={classes.noPrint}
              indicatorColor="secondary"
              textColor="secondary"
              TabIndicatorProps={{
                style: {
                  height: "5px",
                },
              }}
              variant="scrollable"
              scrollButtons="auto"
            >
              {tabs.map((e, i) => (
                <StyledTab
                  key={i}
                  style={{ minWidth: "150px", maxWidth: "unset", backgroundColor: "rgb(250,250,250)", paddingRight: "0px" }}
                  label={
                    <Grid container>
                      <Grid container item md={12}>
                        <Grid item style={{ alignSelf: "center" }}>
                          <Typography style={{ fontSize: "15px", lineHeight: "1.5" }}>
                            {e.fields.messpunkt && e.fields.rekorder.beschreibung ? e.fields.uw : ""}
                          </Typography>
                          <Typography style={{ fontSize: "15px", lineHeight: "1.5" }}>
                            {e.fields.messpunkt && e.fields.rekorder.beschreibung ? getSchaltfeld(e.fields.messpunkt) : e.name}
                          </Typography>
                        </Grid>
                        <Grid item style={{ textAlignLast: "right" }}>
                          {tabs.length > 1 ? (
                            <Button
                              component={"div"}
                              key={i}
                              onClick={(e: React.MouseEvent) => {
                                e.stopPropagation();
                                dispatch(deleteTab(i));
                              }}
                              style={{ minWidth: "unset", marginLeft: "20px", color: "rgb(177, 177, 177)" }}
                            >
                              <Close />
                            </Button>
                          ) : (
                            ""
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  }
                  {...a11yProps(e.index)}
                />
              ))}
              {tabs.length < 7 ? (
                <ButtonInTabs onClick={() => dispatch(addTab(""))}>
                  <Tooltip title="Tab hinzufügen">
                    <AddBox />
                  </Tooltip>
                </ButtonInTabs>
              ) : (
                ""
              )}
            </Tabs>
          </Grid>
          <Grid container item md={2} style={{ marginRight: "0px", paddingRight: "0px" }}>
            <Grid item md={12} style={{ alignItems: "end", marginRight: "0px", paddingRight: "0px" }}>
              <Button
                onClick={() => setOpenSavedSearchesDialog(true)}
                variant="contained"
                color="secondary"
                style={{ float: "right", maxHeight: "36px", alignSelf: "center" }}
              >
                Gespeicherte Suchen
              </Button>
            </Grid>
          </Grid>
          <NetzwirtschaftSavedSearch
            setOpenSavedSearchesDialog={setOpenSavedSearchesDialog}
            openSavedSearchesDialog={openSavedSearchesDialog}
          />
        </Grid>
        {tabs.map((e, i) => (
          <NetzwirtschaftTab viewMode={viewMode} tabData={e} index={i} key={e.index} />
        ))}
      </div>
    </Container>
  );
}
